const messageCal = {
  1: '参数不对,请重新输入',
  2: '用户不存在,请重新输入',
  3: '用户存在,请重新输入',
  4: '手机号不对,请重新输入',
  5: '邮箱不对,请重新输入',
  6: '邀请码错误，请重新输入',
  7: '表单错误，请重新输入',
  8: '注册失败，请重新输入',
  9: '密码错误，请重新输入',
  10: '用户类型错误，请重新输入',
  11: '没有登录，请重新登录',
  12: '不是HCP账号',
  13: '不是patients账号',
  14: '不是carer账号',
  15: '不是admin账号',
  16: '不是cs账号',
  17: 'URL错误',
  18: '数据类型错误',
  19: '申请的用户类型错误',
  20: '不能监控本账号',
  21: '已发申请',
  22: '已建立联系',
  23: '申请不存在',
  24: '状态无效',
  25: '关系状态不对',
  26: '验证码错误',
  27: '令牌错误',
  28: '密码组成错误',
  29: '密码包含空格',
  30: '密码长度错误',
  31: '密码等于用户名',
  32: '连续数字',
  33: '连续字母',
  34: '连续字母',
  35: 'POST数据错误',
  36: '资源不存在',
  37: '没有权限',
  38: '查询参数错误',
  39: '功能未实现',
  40: '处理错误',
  41: '消息不存在',
  42: '消息不存在',
  43: '等待超时',
  44: '邀请不存在',
  45: 'APK不存在',
  46: '更新日志不存在',
  47: '在其他设备登录',
  48: '升级码错误',
  49: 'client_id 错误',
  50: 'client_id 错误',
  51: 'upload 太多',
  52: '禁止登录',
  53: '没有新的命令',
  54: '存在的房间',
  55: '记录不存在',
  56: '记录存在',
  57: '病人已存在',
  58: '机构已存在',
  59: '诊所用户已存在',
  60: '医院用户已存在',
  61: '机构不存在',
  62: '账号已锁定'
}
export default messageCal



// WEBPACK FOOTER //
// ./src/assets/js/message.js